export default {"src":"/_next/static/media/getpacked_Logo_schwarz.79599dfe.svg","height":43,"width":213};